<div class="modal-header">
  <h4 class="modal-title mt-0" id="modal-basic-title">
    <span translate>{{ 'EDIT_ITEM_LINE' | translate }}</span
    >&nbsp;
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  @if (!isLoading) {
    <div class="row" [formGroup]="form">
      <div class="col-12" formGroupName="orp">
        <lib-meta-select-input-horizontal
          table="xb"
          metaId="lagstalle"
          metaDisplay="lagplatsnamn"
          formControlName="lagstalle"
          gungTranslate="INVENTORY_LOCATION"
        ></lib-meta-select-input-horizontal>
      </div>

      <div class="col-12" formGroupName="orp">
        <lib-gung-number-input-horizontal
          formControlName="volymrabatt"
          gungTranslate="ROW_DISCOUNT_%"
          [maxValue]="100"
        ></lib-gung-number-input-horizontal>
      </div>
      <div class="col-12" formGroupName="orp">
        <lib-gung-text-input-horizontal
          formControlName="orpradtext"
          gungTranslate="ORDER_SPECIFIC_TEXT"
        ></lib-gung-text-input-horizontal>
      </div>
      <div class="col-12" formGroupName="orp">
        <lib-gung-select-option-input-horizontal
          [optionsList]="pointOfDeliveryOptions"
          formControlName="ordlevplats1"
          gungTranslate="POD"
        >
        </lib-gung-select-option-input-horizontal>
      </div>

      <div class="col-12">
        <div class="form-group row">
          <label for="skipBrokenBoxFee" class="col-form-label col-12 col-sm-4">
            {{ 'SKIP_BROKEN_BOX_FEE' | translate }}
          </label>
          <div class="col d-flex align-items-center justify-content-end form-check-big pr-4">
            <input type="checkbox" id="skipBrokenBoxFee" class="form-check-input" formControlName="skipBrokenBoxFee" />
          </div>
        </div>
      </div>

      <div class="col-12" formGroupName="orp">
        <lib-gung-text-input-horizontal
          formControlName="artnrkund"
          gungTranslate="CUSTOMER_ITEM_NO"
        ></lib-gung-text-input-horizontal>
      </div>

      <div class="col-12" formGroupName="orp">
        <lib-gung-text-input-horizontal
          formControlName="priceList"
          gungTranslate="PRICE_LIST"
        ></lib-gung-text-input-horizontal>
      </div>

      @if (isCustomerService) {
        <lib-gung-meta-output
          [horizontal]="true"
          [gungTranslate]="'ACQUISITION_METHOD'"
          [value]="product.extra?.ar?.anskaffningssatt"
          metadataTable="xaas"
          metaOptionName="anskaffningssattbeskr">
        </lib-gung-meta-output>
      }
    </div>
  } @else {
    <div class="row">
      <div class="col-12 d-flex flex-row justify-content-center">
        <i class="fa fa-spinner fa-spin fa-5x"></i>
      </div>
    </div>
  }
</div>

<div class="modal-footer">
  <div class="d-flex flex-row" style="gap: 16px">
    <button type="button" class="btn btn-sm btn-primary pl-4 pr-4" (click)="onSave()" translate>SAVE</button>

    <button type="button" class="btn btn-sm btn-outline-primary pl-4 pr-4" (click)="close()" translate>CANCEL</button>
  </div>
</div>
